import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';
import { TIMETABLE } from './timetableRoutes';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const AcademicStructure = lazyPage(() => import('@/pages/academics/AcademicStructure'));
const CurriculumConfiguration = lazyPage(() => import('@/pages/academics/CurriculumConfiguration'));
const Homework = lazyPage(() => import('@/pages/academics/Homework'));
const Promotion = lazyPage(() => import('@/pages/academics/Promotion'));
const PromotionConstraints = lazyPage(() => import('@/pages/academics/PromotionConstraints'));
const Enrollment = lazyPage(() => import('@/pages/academics/Enrollment'));
const GradeConfiguration = lazyPage(() => import('@/pages/academics/GradeConfiguration'));

const STRUCTURE = '/administrator/academics/structure';
const CURRICULUM = '/administrator/academics/curriculum';
const GRADING = '/administrator/academics/grading';

export const academicsRoutes: AppRoute[] = [
  {
    path: 'academics',
    title: 'Academics',
    children: [
      { path: '', title: 'Academics', component: ModuleMenu },
      // Workspaces; each former page is a tab (`?tab=`).
      { path: 'structure', title: 'Academic Structure', component: AcademicStructure },
      { path: 'curriculum', title: 'Curriculum Configuration', component: CurriculumConfiguration, yearScoped: true },
      { path: 'grading', title: 'Grade Configuration', component: GradeConfiguration },
      // Former separate pages; kept so old links and bookmarks land on their tab.
      { path: 'years', title: 'Academic Structure', redirectTo: `${STRUCTURE}?tab=years` },
      { path: 'classes', title: 'Academic Structure', redirectTo: `${STRUCTURE}?tab=classes` },
      { path: 'sections', title: 'Academic Structure', redirectTo: `${STRUCTURE}?tab=sections` },
      { path: 'subjects', title: 'Academic Structure', redirectTo: `${STRUCTURE}?tab=subjects` },
      { path: 'class-sections', title: 'Curriculum Configuration', redirectTo: CURRICULUM },
      { path: 'class-section-subjects', title: 'Curriculum Configuration', redirectTo: CURRICULUM },
      // Periods, rooms and the timetable pages moved to the Timetable module.
      { path: 'resources', title: 'Bell Schedules', redirectTo: `${TIMETABLE}/bell-schedules` },
      { path: 'periods', title: 'Bell Schedules', redirectTo: `${TIMETABLE}/bell-schedules` },
      { path: 'rooms', title: 'Rooms & Resources', redirectTo: `${TIMETABLE}/rooms-resources` },
      { path: 'activities', title: 'Activities', redirectTo: `${TIMETABLE}/activities` },
      { path: 'teacher-availability', title: 'Teachers Availability', redirectTo: `${TIMETABLE}/teacher-availability` },
      { path: 'generate-timetable', title: 'Generate Timetable', redirectTo: `${TIMETABLE}/generate` },
      { path: 'timetable', title: 'Timetable', redirectTo: TIMETABLE },
      { path: 'class-timetable', title: 'Time Tables', redirectTo: `${TIMETABLE}/timetables` },
      { path: 'teacher-timetable', title: 'Time Tables', redirectTo: `${TIMETABLE}/timetables?tab=teacher` },
      { path: 'homework', title: 'Homework', component: Homework, yearScoped: true },
      { path: 'promotion', title: 'Promotion', component: Promotion, yearScoped: true },
      // Rule templates (policies) and their rules are dated, not year-scoped.
      { path: 'promotion/constraints', title: 'Manage Constraints', component: PromotionConstraints },
      { path: 'enrollment', title: 'Enrollment', component: Enrollment, yearScoped: true },
    ],
  },
  // Former standalone Grading module; now the Grade Configuration workspace's
  // two tabs, so old links and bookmarks land on the matching tab.
  {
    path: 'grading',
    title: 'Grade Configuration',
    children: [
      { path: '', title: 'Grade Configuration', redirectTo: GRADING },
      { path: 'systems', title: 'Grading Systems', redirectTo: GRADING },
      { path: 'class-grading', title: 'Class Assignments', redirectTo: `${GRADING}?tab=class-assignments` },
    ],
  },
];
